<template>
  <div class="expired-products">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <div class="row">
          <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
            <el-select 
              class="white"
              clearable
              v-model="searchForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货主：" prop="customerId">
            <el-select 
              class="white"
              clearable
              v-model="searchForm.customerId"
              placeholder="请选择货主"
              @change="changeCustomerList"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="gray white"
              v-model="searchForm.projectId"
              placeholder="请选择项目"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="日期：" prop="date" class="customer-form">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-blue" @click="search">搜索</el-button>
            <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white entry"
          icon="el-icon-download"
          @click="openEntry"
          >录入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`">
              <i :class="scope.row.status == 1?'el-icon-warning':'el-icon-success'"></i>
              {{ scope.row.statusVal }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button :class="scope.row.status == 1?'btn-text':''" type="text" :disabled="scope.row.status == 2" @click="finish(scope.row.id)">完成处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>


    
    <!-- 录入 -->
    <el-dialog
      title="录入"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="entry-dialog"
    >
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <div class="row">
          <el-form-item label="仓库" prop="warehouseId" class="left">
            <el-select 
              class="white"
              clearable
              v-model="entryForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货主：" prop="customerId">
            <el-select 
              class="white"
              clearable
              v-model="entryForm.customerId"
              placeholder="请选择货主"
              @change="changeEntryFormCustomerList"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="日期" prop="date" class="left">
            <el-date-picker
              v-model="entryForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="gray white"
              v-model="entryForm.projectId"
              placeholder="请选择项目"
            >
              <el-option
                v-for="item in entryFormProjectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="title">
          商品信息
        </div>
        <div class="labor-info">
          <div class="row">
            <el-form-item label="商品条码" prop="goodsBarCode" class="left">
              <el-input
                class="gray white"
                v-model="entryForm.goodsBarCode"
                placeholder="请输入"
                clearable
                @blur="bluroodsBarCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品名称" prop="goodsName">
              <el-select
                class="gray white"
                v-model="entryForm.goodsName"
                placeholder="请选择项目"
                filterable
                @blur="childrenSelectBlur"
              >
                <el-option
                  v-for="(item, index) in goodsNameList"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="数量" prop="quantity" class="left">
              <el-input
                class="gray white"
                v-model="entryForm.quantity"
                placeholder="请输入"
                clearable
                @input="quantityInput(entryForm.quantity)"
              ></el-input>
            </el-form-item>
            <el-form-item></el-form-item>
          </div>
          <el-form-item class="processing-progress" label="处理进展" prop="processingProgress">
            <el-input
              class="white"
              type="textarea"
              resize="none"
              v-model="entryForm.processingProgress"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import ChargeRegister from "models/charge-register";
import Expired from "models/data-entry/expired";
import { getInteger } from "common/js/util";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '客户', prop: 'customerName', width: ''},
        {label: '项目', prop: 'projectName', width: ''},
        {label: '商品条码', prop: 'goodsBarCode', width: '120'},
        {label: '商品名称', prop: 'goodsName', width: ''},
        {label: '数量', prop: 'quantity', width: ''},
        {label: '结果', prop: 'remarks', width: '150'},
        {label: '状态', prop: 'statusVal', width: '100'},
      ],
      warehouseList: [],
      customerList: [],
      projectList: [],
      searchForm: {
        warehouseId: '',
        customerId: '',
        projectId: '',
        date: ''
      },

      
      dialog: false,
      entryFormProjectList: [],
      goodsNameList: [],
      entryForm: {
        warehouseId: '',
        date: '',
        customerId: null,
        projectId: null,
        goodsBarCode: null,
        quantity: null,
        goodsName: null,
        processingProgress: null
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        customerId: [
          { required: true, message: '请选择货主', trigger: 'change' }
        ],
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        goodsBarCode: [
          { required: true, message: '请输入商品条码', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        processingProgress: [
          { required: true, message: '请输入处理进展', trigger: 'blur' }
        ]
      },
    }
  },

  created() {
    this.initList()
    this.getWarehouseList()
    this.getCustomerList()
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },

    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    
    /* 获取项目名称 */
    initGetProjectList(type) {
      let customerId
      let warehouseId
      if (type === 'noEntry') {
        customerId = this.searchForm.customerId
        warehouseId = this.searchForm.warehouseId
      } else {
        customerId = this.entryForm.customerId
        warehouseId = this.entryForm.warehouseId
      }
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          if (type === 'noEntry') {
            this.projectList = arr;
            this.searchForm.projectId = arr.length > 0 ? arr[0].id : '';
          } else {
            this.entryFormProjectList = arr;
            this.entryForm.projectId = arr.length > 0 ? arr[0].id : '';
          }
        }
      });
    },
    
    initList() {
      let pageNo = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let customerId = this.searchForm.customerId
      let projectId = this.searchForm.projectId
      let entryDate = this.searchForm.date
      let data = {
        pageNo,
        warehouseId,
        customerId,
        projectId,
        entryDate
      }
      Expired.getExpiredProductsList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.entryDate
            obj.warehouseName = i.warehouseName
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.goodsBarCode = i.barCode
            obj.goodsName = i.goodsName
            obj.quantity = i.quantity
            obj.remarks = i.dealInfo
            obj.status = i.status
            obj.statusVal = i.status == 1 ? '待处理':'已处理' 
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    initGoodsName() {
      let customerId = this.entryForm.customerId
      let code = this.entryForm.goodsBarCode
      if (!code) {
        return
      }
      ChargeRegister.getGoodsName(code, customerId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.name = i
            arr.push(obj)
          })
          this.goodsNameList = arr
          this.entryForm.goodsName = arr.length > 0 ? arr[0].name: null
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    changeCustomerList() {
      this.initGetProjectList('noEntry')
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    changeEntryFormCustomerList() {
      this.initGetProjectList('entry')
    },
    
    openEntry() {
      this.dialog = true
    },

    closeDialog() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.entryForm.customerId = null
      this.entryForm.projectId = null
      this.entryForm.goodsBarCode = null
      this.entryForm.quantity = null
      this.entryForm.goodsName = null
      this.entryForm.processingProgress = null
      this.goodsNameList = []
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let entryDate = this.entryForm.date
          let customerId = this.entryForm.customerId
          let projectId = this.entryForm.projectId
          let barCode = this.entryForm.goodsBarCode
          let quantity = this.entryForm.quantity
          let goodsName = this.entryForm.goodsName
          let dealInfo = this.entryForm.processingProgress
          let data = {
            warehouseId,
            entryDate,
            customerId,
            projectId,
            barCode,
            quantity,
            goodsName,
            dealInfo
          }
          Expired.postExpiredProducts(data).then(res => {
            if (res.success) {
              this.initList()
              this.closeDialog()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    quantityInput(v) {
      this.entryForm.quantity = getInteger(v);
    },

    finish(id) {
      this.$confirm("是否完成过期产品的处理？", "完成处理", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = { id };
        Expired.postFinishExpired(data).then(res => {
          if (res.success) {
            this.initList()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    bluroodsBarCode() {
      this.initGoodsName()
    },
    
    childrenSelectBlur(e){
      let str = e.target.value
      if (str) {
        this.entryForm.goodsName = str
      }
    },
  }
}
</script>

<style lang='scss'>
.expired-products {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .entry {
      padding: 0px 14px;
    }
    .el-form {
      min-height: 72px;
      .el-form-item {
        .el-date-editor {
          width: 192px;
        }
      }
      .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
    .operation-btn {
      padding-top: 48px;
    }
  }
  
  .table {
    padding: 16px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      display: flex;
      align-items: center;
    }
    .status1,
    .status2 {
      width: 70px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      border-radius: 4px;
    }
    .status1 {
      color: #FF6A3A;
      background: #FFEDE7;
    }
    .status2 {
      color: #22A979;
      background: #E4F5EF;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  
  .entry-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .entry-form {
      .row {
        display: flex;
        justify-content: flex-start;
        .el-form-item {
          width: 50%;
        }
        .left {
          margin-right: 30px;
        }
      }
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
      }
      .title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
      .labor-info {
        padding: 20px;
        border: 1px solid #eee;
        .processing-progress {
          margin-top: 16px;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
